// src/components/section-templates/BentoBoxSection.jsx
import React from "react";
import "./BentoBoxSection.css";
import { MotionContainer, MotionItem } from "../../animations/MotionWrappers";

export default function BentoBoxSection({ title, description, items }) {
  const topItems = items.slice(0, 3);
  const bottomItem = items[3];

  return (
    <section className=" bento-section">
      {title && <h2>{title}</h2>}
      {description && <p className="bento-description">{description}</p>}

      <MotionContainer
        className="container bento-container"
        // add a 0.15s delay before animating the first item
        delayChildren={0.15}
      >
        {topItems.map((img, i) => (
          <MotionItem key={i} className="bento-item bento-item--square">
            <img src={img.src} alt={img.alt || ""} />
          </MotionItem>
        ))}

        {bottomItem && (
          <MotionItem className="bento-item bento-item--wide">
            <img src={bottomItem.src} alt={bottomItem.alt || ""} />
          </MotionItem>
        )}
      </MotionContainer>
    </section>
  );
}
